import { createFileRoute, Navigate } from '@tanstack/react-router';
import { useAuth } from '../features/auth/use-auth.js';

function IndexRedirect() {
  const { status, user } = useAuth();
  if (status === 'idle' || status === 'loading') {
    return (
      <div className="flex min-h-screen items-center justify-center text-body text-[var(--fg-muted)]">
        Bejelentkezés ellenőrzése…
      </div>
    );
  }
  return <Navigate to={status === 'authenticated' && user ? '/app' : '/login'} replace />;
}

export const Route = createFileRoute('/')({
  component: IndexRedirect,
});
